import styled from 'styled-components'

export const AssigneesWrapper = styled.div`
  .ant-select-selection-overflow-item {
    &:first-child {
      max-width: 300px;
    }
  }
`
